import { render } from "./StrategyDetails.vue?vue&type=template&id=687ea5d1&scoped=true&lang=true"
import script from "./StrategyDetails.vue?vue&type=script&lang=js"
export * from "./StrategyDetails.vue?vue&type=script&lang=js"

import "./StrategyDetails.vue?vue&type=style&index=0&id=687ea5d1&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-687ea5d1"

export default script